module.exports = __webpack_public_path__ + "d242d8b14baba9ed8830fc77f53e3eb5.svg";